/*
 * Copyright (C) 2025 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {BlockPreviewLayout} from './BlockPreviewLayout'
import SVGWrapper from '@canvas/svg-wrapper'
import {useScope as createI18nScope} from '@canvas/i18n'

const I18n = createI18nScope('page_editor')

export const VideoBlockPreview = () => (
  <BlockPreviewLayout
    image={<SVGWrapper ariaHidden={true} url="/images/block-content-editor/video.svg" />}
    title={I18n.t('Media')}
    description={[
      I18n.t('Add an embedded video to your page. This either can be YouTube or Studio embedding.'),
    ]}
    legend={I18n.t("For the time being, you can't add additional text to this block.")}
  />
)
